import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { Redirect, withRouter } from 'react-router';
import { FETCH_AD, UPDATE_AD } from '../../redux/Ads';
import AdNewForm from './AdNewForm/AdNewForm';

const AdUpdate = (props) => {
  const { fetchAd, adDetails, redirectPromotion, match: { params: { adId, }, }, } = props;
  useEffect(() => {
    fetchAd(adId);
  }, [fetchAd]);

  const initialAdDetails = useMemo(() => {
    const formValues = (({ description, brand_id, model, vehicle_type, cubic_capacity,
                           drive_type, power, gear_box, color, metailic_lacquer,
                           damage_unrepaired, heated_grips, box, windshield, abs,
                           price, vat_rate, ful_service_history, new_inspection,
                           last_inspection, next_hu, first_registration, total_mileage,
                           vin, number_of_previous_owners, }) => (
      { description,
        brand_id: brand_id?.toString(),
        model,
        vehicle_type,
        cubic_capacity,
        drive_type,
        gear_box,
        color,
        damage_unrepaired,
        metailic_lacquer,
        heated_grips,
        box,
        abs,
        vat_rate,
        price,
        windshield,
        ful_service_history,
        new_inspection,
        last_inspection,
        next_hu,
        vin,
        total_mileage,
        first_registration,
        number_of_previous_owners,
        power, }))(adDetails);

    const [highlight_1, highlight_2] = adDetails.highlights || ['', ''];
    return { ...formValues, highlight_1, highlight_2, };
  }, [adDetails]);

  const initialValues = {
    vin: '',
    damage_unrepaired: false,
    heated_grips: false,
    box: false,
    windshield: false,
    abs: false,
    metailic_lacquer: false,
    ful_service_history: false,
    new_inspection: false,
    ...initialAdDetails,
  };
  const handleSubmit = (values) => {
    props.updateAd({ values, adId, });
  };

  if (redirectPromotion) {
    return <Redirect to={`/dashboard/ads/${adId}/promote`} />;
  }

  return (
    <div className="row">
      {adDetails.id &&
        <AdNewForm onSubmit={handleSubmit} initialValues={initialValues} existingPhotos={adDetails.photos} />
      }
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    adId: get(state, ['ads', 'ad_data', 'id']),
    adDetails: get(state, ['ads', 'ad_data']),
    redirectPromotion: get(state, ['ads', 'redirectPromotion']),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchAd: (id) => dispatch(FETCH_AD(id)),
    updateAd: (data) => dispatch(UPDATE_AD(data)),
  };
};

AdUpdate.propTypes = {
  fetchAd: PropTypes.func.isRequired,
  redirectPromotion: PropTypes.bool.isRequired,
  adDetails: PropTypes.object.isRequired,
  updateAd: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
};


export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
  )(AdUpdate));
